import { resendInvite } from './types';

export * from './actions';

const resendInviteReducerObject = {
  [resendInvite.request]: (state) =>
    state.withMutations((currentState) =>
      currentState
        .setIn(['resendInvite', 'network', 'error'], false)
        .setIn(['resendInvite', 'network', 'loading'], true)
        .setIn(['resendInvite', 'network', 'success'], false),
    ),
  [resendInvite.success]: (state) =>
    state.withMutations((currentState) =>
      currentState
        .setIn(['resendInvite', 'network', 'error'], false)
        .setIn(['resendInvite', 'network', 'loading'], false)
        .setIn(['resendInvite', 'network', 'success'], true),
    ),
  [resendInvite.failure]: (state) =>
    state.withMutations((currentState) =>
      currentState
        .setIn(['resendInvite', 'network', 'error'], true)
        .setIn(['resendInvite', 'network', 'loading'], false)
        .setIn(['resendInvite', 'network', 'success'], false),
    ),
};

export default resendInviteReducerObject;
